<template>
  <v-footer
    class="footer-container hidden-sm-and-down"
    :class="avvisi && avvisi.length > 0 ? 'footer-alert' : ''"
    id="dashboard-core-footer"
    fixed
  >
    <div v-if="avvisi && avvisi.length > 0">
      <div class="banner-avvisi" v-for="avviso in avvisi" v-bind:key="avviso">
        <h4>{{ avviso }}</h4>
      </div>
    </div>
    <v-row v-else justify="center" no-gutters>
      <v-col
        v-for="voce in footer"
        v-bind:key="voce"
        style="text-align: center"
      >
        <span class="primary--text" v-html="voce" /> </v-col
    ></v-row>
  </v-footer>
</template>

<script>
export default {
  name: "DashboardCoreFooter",
  computed: {
    avvisi() {
      if (
        window &&
        window.selectedLanguage &&
        window.systemData &&
        window.systemData.avvisi &&
        window.systemData.avvisi[window.selectedLanguage]
      )
        return window.systemData.avvisi[window.selectedLanguage];
      else return [];
    },
  },
  data() {
    return {
      footer: [],
    };
  },
  mounted() {
    this.footer = window.systemData.SYSTEM.webFooter;
  },
};
</script>

<style scoped>
.banner-avvisi {
  text-align: center;
  color: white;
  width: 100%;
}
.footer-alert {
  background-color: red !important;
}
</style>